export const CALENDAR_INTERACTION_SMART_ACTION_DIALOG_ID =
  'smart-action-dialog-interactionhandler';
